import React from 'react'

export default function Footer() {
    return (
        <div>
            <footer class="site-footer">
                <div class="container">
                    <div class="row px-2">
                        <div class="col-sm-12 col-md-6">
                            <h6>About</h6>
                            <p class="text-justify">We pride ourselves on serving our customers with great taste in leather wearables and accessories, and we are extremely proud of our new Store at the center of Zainab Market, Karachi. We are a brand that not only represents this – but is also about pushing the boundaries of what is possible in the world of fashion. Nukhba is an innovative Premium Leather & Fashion Brand and we believe strongly in our vision which is to provide the Luxury our customers truly deserve.</p>
                        </div>

                       
                    </div>
                    <hr/>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 col-sm-6 col-xs-12">
                            <p class="copyright-text">Copyright &copy; 2023 All Rights Reserved by 
                                <a href="#">Nukhba</a>
                            </p>
                            <p class="copyright-text">Site developed by: <a href='/Metatech.pdf' target="_blank" download> Meta Tech</a>
                                
                            </p>
                        </div>

                        <div class="col-md-4 col-sm-6 col-xs-12">
                            <ul class="social-icons">
                                <li><a class="facebook" href="https://www.facebook.com/nukhbapk" target="blank"><i class="fa fa-facebook"></i></a></li>
                                <li><a class="twitter" href="#"><i class="fa fa-twitter"></i></a></li>
                                <li><a class="dribbble" href="#"><i class="fa fa-dribbble"></i></a></li>
                                <li><a class="linkedin" href="#"><i class="fa fa-linkedin"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}